

const signalR = require("@aspnet/signalr");
let chatSignal = new signalR.HubConnectionBuilder()
    .withUrl("/chathub")
    .build();

window.chatSignal = chatSignal

let start = () => {
    try {
        window.chatSignalStared = chatSignal.start();
    } catch (err) {
        setTimeout(() => start(), 5000);
    }
}
start()
chatSignal.onclose(start)